import { dcDueActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'
import { log } from '_services'

const initialState = {
    selectedMessage: undefined,
    loading: false
};

export const reducer = createReducer(initialState, {
    [dcDueActions.setSelectedMessage]: (state, action) => {
        state.selectedMessage = action.payload.epno;
    },
    [dcDueActions.markReadFailure]: (state, action) => {
        log.error('Error marking note as read. epno: ' + action.payload.epno + ' error: ' + action.payload.error);
    },
    [dcDueActions.loadRequest]: (state, action) => {
        state.loading = true;
    },
    [dcDueActions.loadSuccess]: (state, action) => {
        state.loading = false;
    },
    [dcDueActions.loadFailure]: (state, action) => {
        state.loading = false;
        log.error('Error loading DC Due notes. error: ' + action.payload.error);
    },
    [dcDueActions.clearSelection]: (state, action) => {
        state.selectedMessage = undefined;
    }
})


